// Load Bootstrap JS
import bootstrap from 'bootstrap'

// Load Styles
import '../scss/main.scss';
import initEmailAddress from "./modules/init_email_address";
import initServicesSlider from "./modules/init_services_slider";
import initHeadlineSlider from "./modules/init_headline_slider";
import initWorkflow from "./modules/init_workflow";
import initTestimonialsSlider, { initTestimonialsLogosSlider } from "./modules/init_testimonials_slider";
import initEmployeeTestimonialsSlider from "./modules/init_employee_testimonials_slider";
import initReferencesSlider from "./modules/init_references_slider";
import initPartnersSlider from "./modules/init_partners_slider";
import initOfferingsSlider from "./modules/init_offerings_slider";
import initBenefitsSlider from "./modules/init_benefits_slider";
import initGalleryLightbox from "./modules/init_gallery_lightbox";
import initStickyNavbar from "./modules/init_sticky_navbar";
// Demo of using .env variables
// console.log(`Google Maps API Key: ${process.env.GOOGLE_MAPS_API_KEY}`);

window.addEventListener('load',()=>{
  initStickyNavbar('#site-header');
  initEmailAddress('.ks-email');
  initServicesSlider('.ks-services__swiper');
  initHeadlineSlider('.ks-headline-slider__swiper');
  initWorkflow('[data-ks-workflow]');
  initTestimonialsSlider('.ks-testimonials__swiper');
  initTestimonialsLogosSlider('.ks-testimonials__logos-swiper');
  initEmployeeTestimonialsSlider('.ks-employee-testimonials__swiper');
  initReferencesSlider('.ks-references__swiper');
  initPartnersSlider('.ks-partners__swiper');
  initOfferingsSlider('.ks-offerings__swiper');
  initBenefitsSlider('.ks-benefits__swiper');
  initGalleryLightbox('.ks-video-gallery');
})
